import '../../styles/CaseListMetrics.css';

function MetricTile({ label, value, suffix }) {
    const isEmpty = value === null || value === undefined;
    return (
        <div className="case-list-metric-tile">
            <div className="case-list-metric-tile__label">{label}</div>
            <div className="case-list-metric-tile__value">
                {isEmpty ? (
                    <span className="case-list-metric-tile__empty">—</span>
                ) : (
                    <>
                        <span>{value}</span>
                        {suffix ? (
                            <span className="case-list-metric-tile__suffix">{suffix}</span>
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
}

export default MetricTile;
